import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M37.316 2.989a.37.37 0 0 0-.278-.286c-4.575-1.119-15.148 2.868-20.876 8.594a25 25 0 0 0-2.784 3.289c-1.766-.156-3.533-.026-5.038.63-4.248 1.87-5.485 6.748-5.83 8.847a.753.753 0 0 0 .825.875l6.821-.753q.008.771.093 1.54c.034.354.192.686.445.937l2.642 2.635c.251.253.583.41.937.445q.764.086 1.53.093l-.748 6.813a.756.756 0 0 0 .875.824c2.095-.336 6.982-1.573 8.84-5.82.657-1.506.79-3.264.64-5.022a25 25 0 0 0 3.297-2.784c5.746-5.717 9.71-16.054 8.609-20.857M22.974 17.026a3.75 3.75 0 1 1 5.301-5.305 3.75 3.75 0 0 1-5.3 5.305"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M13.156 31.206c-.428.428-1.115.596-1.941.739-1.857.316-3.497-1.289-3.163-3.166.127-.712.503-1.71.738-1.944a.342.342 0 0 0-.285-.582 4.7 4.7 0 0 0-2.745 1.338c-1.837 1.838-2.01 8.659-2.01 8.659s6.825-.173 8.662-2.012a4.66 4.66 0 0 0 1.338-2.747c.029-.326-.369-.52-.594-.285"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }